<div class="content-wrapper">
	<div class="cards-wrapper">
		<ng-container *ngIf="statistics.length > 0 && !getDataError && !isLoading">
			<ra-stats-card
				*ngFor="let statistic of statistics"
				[agentStat]="statistic"
			></ra-stats-card>
		</ng-container>

		<ng-container *ngIf="isLoading">
			<div class="loading">
				<div class="loader"></div>
			</div>
		</ng-container>
	</div>

	<ng-container *ngIf="getDataError">
		<h4>{{ "sales-stats.get-data-error" | translate }}</h4>
	</ng-container>

	<ng-container *ngIf="statistics.length === 0 && !getDataError && !isLoading">
		<h4>{{ "sales-stats.no-data" | translate }}</h4>
	</ng-container>
</div>
